var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "70px",
    height: "70px",
    viewBox: "0 0 70 70",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u8054\u7CFB\u90AE\u7BB1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u9875\\u9762-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u53CD\\u9988\\u4FE1\\u606F\\u72B6\\u60012",
    transform: "translate(-77.000000, -1700.000000)",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-7",
    transform: "translate(77.000000, 1672.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u8054\\u7CFB\\u90AE\\u7BB1",
    transform: "translate(0.000000, 28.000000)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 25.3739595,
    y1: 32.3702257,
    x2: 8.355902,
    y2: 52.6241939,
    id: "\\u8DEF\\u5F84-222",
    stroke: "#33395F"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 43.8568748,
    y1: 32.3702257,
    x2: 62.5605221,
    y2: 52.6241939,
    id: "\\u8DEF\\u5F84-223",
    stroke: "#33395F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.355902,15.7619048 L28.8298809,33.2602258 C32.5530495,36.4422744 38.0329937,36.4594834 41.7760741,33.3008814 L62.5605221,15.7619048 L62.5605221,15.7619048",
    id: "\\u8DEF\\u5F84-220",
    stroke: "#00A1F0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    stroke: "#33395F",
    x: 6.28571429,
    y: 13,
    width: 58,
    height: 41.4285714,
    rx: 6
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.6fc89d7fe84790a2274ad9ef97a28a92.svg";
export { ForwardRef as ReactComponent };